function onEscape() {
	return {
		restrict: "A",

		scope: {
			fn: "&onEscape"
		},
		// https://embed.plnkr.co/plunk/CpsjpK

		link: function(scope, elem) {
			elem.on("keydown", function(e) {
				if(e.code === "Escape") {
					scope.fn();
					scope.$apply();
				}
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.on-escape", [])
	.directive("onEscape", onEscape).name;
